import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
const SearchBar = ({ options, searchTerm, statusFilter, onSearch }) => {
  const [localSearch, setLocalSearch] = useState(searchTerm || "");
  const [localStatusFilter, setLocalStatusFilter] = useState(statusFilter || "");
  const [showClearButton, setShowClearButton] = useState(false);
  const inputRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    setLocalSearch(searchTerm || "");
    setShowClearButton(!!(searchTerm && searchTerm.trim()));
  }, [searchTerm]);

  useEffect(() => {
    setLocalStatusFilter(statusFilter || "");
  }, [statusFilter]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setLocalSearch(value);
    setShowClearButton(!!value.trim());
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
      inputRef.current?.blur();
    } else if (e.key === "Escape") {
      handleClearSearch();
      inputRef.current?.blur();
    }
  };

  const handleSearch = () => {
    const trimmedSearch = localSearch.trim();
    if (onSearch) {
      onSearch(trimmedSearch, localStatusFilter);
    }
  };

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    setLocalStatusFilter(newStatus);

    // Trigger search with current search term and new status
    if (onSearch) {
      onSearch(localSearch.trim(), newStatus);
    }
  };

  const handleClearSearch = () => {
    setLocalSearch("");
    setShowClearButton(false);
    if (onSearch) {
      onSearch("", localStatusFilter);
    }
    inputRef.current?.focus();
  };

  return (
    <div className="search-bar-container">
      <div className="search-input-wrapper">
        <input
          ref={inputRef}
          type="text"
          placeholder={t("admin.search_bar.placeholder")}
          value={localSearch}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          className="search-input"
          aria-label={t("admin.search_bar.aria_search")}
          autoComplete="off"
          spellCheck="false"
        />

        {showClearButton && (
          <button
            className="search-icon-button clear-mode"
            onClick={handleClearSearch}
            aria-label={t("admin.search_bar.aria_clear")}
            type="button"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        )}
      </div>
      
      <div className="filters">
        <select
          value={localStatusFilter}
          onChange={handleStatusChange}
          className="status-filter"
          aria-label={t("admin.search_bar.aria_filter")}
        >
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default SearchBar;